module.exports = __webpack_public_path__ + "logo_full-efefe08462ede002abb7fc1e69005cbb.png";